import { Reducer } from 'redux';
import { LoginActionTypes, LoginState } from './types';

const initialState: LoginState = {
  error: undefined,
  data: undefined,
  isTermsAccepted: false,
  submitting: false,
  isAuthFailed: true,
  isOTPActivated: undefined,
  isSingedInForExternalApp: false,
  isSingedInWithOTP: false
};

const reducer: Reducer<LoginState> = (state = initialState, action: any) => {
  switch (action.type) {
    case LoginActionTypes.FETCH_REQUEST: {
      return {
        ...initialState,
        submitting: true
      };
    }
    case LoginActionTypes.FETCH_SUCCESS: {
      const { data, isTermsAccepted } = state;
      return { ...initialState, data, isTermsAccepted, isAuthFailed: false };
    }
    case LoginActionTypes.AUTH_FAILURE: {
      const {
        isOTPActivated,
        isSingedInWithOTP,
        isAuthFailed,
        isSingedInForExternalApp
      } = state;
      return {
        ...initialState,
        isAuthFailed,
        isOTPActivated,
        isSingedInWithOTP,
        isSingedInForExternalApp,
        error: action.payload
      };
    }

    case LoginActionTypes.ACCEPT_SIGNIN_TERMS: {
      return {
        ...state,
        submitting: true
      };
    }
    case LoginActionTypes.ACCEPT_SIGNIN_TERMS_SUCCESS: {
      return {
        ...initialState,
        isTermsAccepted: true
      };
    }
    case LoginActionTypes.ACCEPT_SIGNIN_TERMS_FAILURE: {
      return {
        ...initialState,
        error: action.payload
      };
    }
    case LoginActionTypes.SELECT_SESSION_ORG_ROLE: {
      return {
        ...state,
        submitting: true
      };
    }
    case LoginActionTypes.SELECT_SESSION_ORG_ROLE_SUCCESS: {
      return {
        ...initialState,
        data: action.payload
      };
    }
    case LoginActionTypes.SELECT_SESSION_ORG_ROLE_FAILURE: {
      return {
        ...initialState,
        error: action.payload
      };
    }
    case LoginActionTypes.FETCH_OTP_STATUS: {
      return {
        ...state,
        isOTPActivated: action.payload
      };
    }
    case LoginActionTypes.FETCH_OTP_CODE: {
      return {
        ...state,
        error: undefined
      };
    }
    case LoginActionTypes.FETCH_OTP_CODE_SUCCESS: {
      return {
        ...state,
        error: undefined,
        data: action.payload
      };
    }
    case LoginActionTypes.FETCH_OTP_CODE_FAILURE: {
      return {
        ...state,
        error: undefined,
        data: {}
      };
    }
    case LoginActionTypes.SIGN_IN_WITH_OTP_CODE: {
      return {
        ...state,
        error: undefined
      };
    }
    case LoginActionTypes.SIGN_IN_WITH_OTP_CODE_SUCCESS: {
      return {
        ...state,
        error: undefined,
        isSingedInWithOTP: true
      };
    }
    case LoginActionTypes.SIGN_IN_WITH_OTP_CODE_FAILURE: {
      return {
        ...state,
        isSingedInWithOTP: false,
        error: action.payload
      };
    }
    case LoginActionTypes.SIGN_IN_WITH_TEMPORARY_CODE: {
      return {
        ...state,
        error: undefined
      };
    }
    case LoginActionTypes.SIGN_IN_WITH_TEMPORARY_CODE_SUCCESS: {
      return {
        ...state,
        error: undefined,
        isSingedInWithTemporaryCode: true
      };
    }
    case LoginActionTypes.SIGN_IN_WITH_TEMPORARY_CODE_FAILURE: {
      return {
        ...state,
        isSingedInWithTemporaryCode: false,
        error: action.payload
      };
    }
    case LoginActionTypes.SIGN_IN_FOR_EXTERNAL_APP_SUCCESS: {
      return {
        ...state,
        error: undefined,
        isSingedInForExternalApp: true
      };
    }
    case LoginActionTypes.SIGN_IN_FOR_EXTERNAL_APP_FAILURE: {
      return {
        ...state,
        isSingedInForExternalApp: false,
        error: action.payload
      };
    }
    case LoginActionTypes.RESET_ERROR: {
      return {
        ...state,
        error: undefined
      };
    }
    default: {
      return state;
    }
  }
};

export { reducer as LoginReducer };
